import { FigmaLogoIcon } from "@radix-ui/react-icons";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Icons } from "@/components/icons";
import { cellConfig } from "@/lib/cell";
import useDeflowSessionStore from "@/stores/useDeflowSessionStore";
import { Deflow } from "@/clients/deflow";

export const Route = createFileRoute("/plugin/figma/onboarding/3")({
  component: OnboardingStep3,
});

function OnboardingStep3() {
  const { tokens } = useDeflowSessionStore();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  return (
    <div>
      <div className="px-8 pt-8">
        <div className="w-full">
          <CardHeader>
            <CardTitle className="flex">
              {`Link your Figma account`}
              <FigmaLogoIcon className="ml-2" />
            </CardTitle>
            <CardDescription>
              We need to connect to your Figma account with your Deflow account
              so that you can publish your design assets.
            </CardDescription>
            <CardDescription>
              You will be redirected to Figma in your browser where you need to
              click <strong>Allow access</strong>.
            </CardDescription>
          </CardHeader>
          <CardFooter className="flex">
            <Button
              className="mx-auto"
              disabled={!tokens?.accessToken || isLoading}
              onClick={async () => {
                if (!tokens?.accessToken) {
                  return;
                }
                setIsLoading(true);
                const response = await Deflow.get({
                  url: "/v1/oauth2/authorize",
                  token: tokens?.accessToken,
                });

                if (!response?.url) {
                  return;
                }

                // Browser-safe base64 encode (the receiving handover route
                // decodes via window.atob).
                const redirect = response?.url
                  ? window.btoa(response.url)
                  : undefined;

                const url = `${cellConfig().appUrl}/handover?token=${
                  tokens?.accessToken
                }${redirect ? "&redirect=" + redirect : ""}`;

                setIsLoading(false);
                window.open(url, "_blank");
                navigate({ to: "/plugin/figma/onboarding/4", replace: true });
              }}
            >
              {isLoading && (
                <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
              )}
              Link accounts
            </Button>
          </CardFooter>
        </div>
      </div>
    </div>
  );
}
